import { IAdminScreenDefinitions } from "./adminScreenTypes"

export const AdminScreenDefinitions = (toggles: string[], features: string[]): IAdminScreenDefinitions => ({
   // Admin screen definitions isnt being used in the app yet, but it is a good place to define the screens that will be used in the future.
})
